export class NumberFormat {
  constructor(readonly decimalDigits: number, readonly decimalDelimiter: string, readonly thousandDelimiter: string) {}
}
